import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class About extends Component {

  render() {
    const loc = cookies.get('locale')

    if(loc === 'ja') {
    return (
      <div className='about'>
        このサイトについて
        <div className='comment_header'>
          エンジニアの集合知をノードグラフにして図解するSNS
        </div>
        エンジニアの皆さんの知識をノードグラフにマッピングすることで、技術要素の関係が分かりやすく理解できるようになる、と考えて作りました。
        <div className='comment_header'>
          これ作った人
        </div>
        ジャバ・ザ・ハットリ<br/>
        <br />
        ブログ：<a href="http://tango-ruby.hatenablog.com/" target="_blank" rel="noopener noreferrer">ベルリンのITスタートアップで働くジャバ・ザ・ハットリの日記</a><br/>
        Twitterアカウント： <a href="https://twitter.com/nodenodenode1" target="_blank" rel="noopener noreferrer">@nodenodenode1</a><br />
        <br />
        <br />
        <br />
        <br />
        <div className='comment_header'>
          利用規約
        </div>
      当サービスを利用する場合は、本規約の内容をご承諾いただいたものとします。本規約の内容は、必要に応じて変更することがあります。利用の際には最新の利用規約をご確認ください。
      <br/>
      <br/>

      サービスの利用
      <br/>
      当サイトの管理者（以下、「管理者」）は、事前に利用者の投稿内容を閲覧することはしません。投稿の内容（真偽、正確性、第三者の権利を侵害していないこと等）や利用の状態については一切保証しません。サービスの利用は、利用者ご自身の責任において行ってください。
      <br/>
      <br/>
      禁止行為
      <br/>
      当サイトにおいて以下の行為を禁止します。
      <br/>
      - 公序良俗に反するおそれのある投稿
      <br/>
      - 著作権などの第三者の知的財産権を侵害し、または侵害を助長する行為
      <br/>
      - 法に抵触するサイトへのリンク
      <br/>
      - 第三者のプライバシーを侵害し、もしくは秘密を漏えいするような投稿
      <br/>
      - 第三者に対する誹謗中傷または名誉き損、もしくは他者に対して不利益または不快感を与えるおそれのある投稿
      <br/>
      - 虚偽または故意に誤解を与える投稿
      <br/>
      - 民族的・人種的差別につながる投稿、倫理的観点から問題のある投稿
      <br/>
      - 特定の政党もしくは政治団体のための活動、宗教活動または専ら営利を目的とした投稿、その他勧誘、宣伝、広告を目的とした内容の掲示
      <br/>
      - 自分以外の人物を名乗ったり、代表権や代理権がないにもかかわらず文化団体などの組織を名乗ること、または他の人物や組織と提携、協力関係にあると偽ったりすること
      <br/>
      - 他の利用者の個人情報を収集し蓄積すること、またはこれらの行為をしようとすること
      <br/>
      - 当サイトのサーバーもしくはネットワークを妨害したり、混乱させたりすること
      <br/>
      - 本サイトの目的及び開設されたテーマとは無関係な投稿
      <br/>
      - 管理者等が禁止を明示した投稿または削除した投稿と同一または類似する内容の投稿
      <br/>
      <br/>
      投稿内容に対する権利等
      <br/>
      - 本サービスを利用して投稿した内容について、自らが投稿又は送信することについての適法な権利を有していること、及び投稿内容が第三者の権利を侵害しないことについて、表明し、保証するものとします。<br />
      - ユーザーは当社に対し、投稿内容について、無償にて利用(複製、複写、改変、第三者への再許諾その他のあらゆる利用を含む。)する権利を許諾するものとします。
      <br/>
      <br/>
      投稿内容の削除
      <br/>
      管理者は、本規約に反していると認められる投稿等について、利用者の同意を得ることなしに削除することができるものとする。
      <br/>
      <br/>
      免責事項
      <br/>
      利用者が当サイトの利用により第三者の権利を侵害し、または第三者に対して損害を与えたことに関連して生じた全ての苦情や請求について、管理者は損害賠償その他の責任を負わない。
      <br/>
      管理者は、利用者による当サイトへの投稿内容などを削除し、または保存しなかったことについて一切責任を負わず、その理由説明義務を負わない。
      <br />
      <br />
      本規約は2018年1月26日から施行される
      <div className='comment_header'>
        プライバシーポリシー
      </div>

      node-node-nodeは、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、個人情報の保護を推進致します。<br />
      <br />
      個人情報の管理<br />
      個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。<br />
      <br />
      個人情報の第三者への開示・提供の禁止<br />
      ユーザーからお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。<br />
      <br />
      - ユーザーの同意がある場合<br />
      - ユーザーが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合<br />
      - 法令に基づき開示することが必要である場合<br />
      <br />
      法令、規範の遵守と見直し<br />
      当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。<br />
      <br />
     </div>
    )
    } else {
      return (
        <div className='about'>
          About this site
          <div className='comment_header'>
            node-node-node is SNS for sharing IT knowledge with Node Graph
          </div>
          It is an online Node Graph for sharing and discovering great ideas. Cross-posting and linking from your own blogs are welcome.
          <div className='comment_header'>
            Created by
          </div>
          Jabba the HuttRi. Creator of THIS WEBSITE, I am a software engineer from Japan, living in Berlin Germany.
          <br />
          {/* blog: <a href="http://tango-ruby.hatenablog.com/" target="_blank" rel="noopener noreferrer">Here is a link to the blog. It's written in Japanese</a><br/> */}
          Twitter account: <a href="https://twitter.com/nodenodenode1" target="_blank" rel="noopener noreferrer">@nodenodenode1</a>
          <br />
          <br />
          <br />
          <br />
          <div className='comment_header'>
            node-node-node Terms of Service
          </div>
          Terms <br />
          By accessing this website, you are agreeing to be bound by these node-node-node Terms of Service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this web site are protected by applicable copyright and trade mark law.<br />
          <br />
          Disclaimer<br />
        The materials on the website are provided "as is". node-node-node makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights. Further, node-node-node does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its Internet web site or otherwise relating to such materials or on any sites linked to this site.<br />
        <br />
        Copyright <br/ >
          Users agree and certify that they have rights to share all content that they post on node-node-node. This rule applies to prose, code snippets, collections of links, etc. If you believe that a user has plagiarized content, misrepresented their identity, misappropriated work, or otherwise run afoul of DMCA regulations, please email contact@node-node-node.com<br />
        <br />
        Modifications <br />
        node-node-node may revise these terms for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms.
        <br />
        <br />
          Effective: January 26, 2018


        <div className='comment_header'>
        Privacy Policy
        </div>
        This Privacy Policy governs the manner in which node-node-node collects, uses, maintains and discloses information collected from users (each, a "User") of node-node-node website ("Site").<br />
        <br />
        Personal identification information<br />
        We may collect personal identification information from Users in a variety of ways in connection with activities, services, features or resources we make available on our Site. Users may visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.<br />
<br />
        Non-personal identification information<br />
        We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.<br />
<br />
        Web browser cookies<br />
        Our Site may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.<br />

        </div>

      )
    }
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(About)



// WEBPACK FOOTER //
// ./src/components/fixedComponents/About.js